module.exports = __webpack_public_path__ + "static/media/retino.e60f2ef0.jpg";